import DateInput from 'elements/input/DateInput'
import lodash from 'lodash'
import { styled } from 'opensolar-ui'
import { FC, useEffect, useMemo } from 'react'
import { SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'
import { dateParserYYYYMMDD } from 'util/misc'
import { DATE_CHOICES } from '../types'

interface PropTypes {
  source: string
  fieldId: string
  afterField: string
  beforeField: string
}

const StyledDateInput = styled(DateInput)({
  width: 180,
})

const DateFilter: FC<PropTypes> = ({ source, fieldId, afterField, beforeField }) => {
  const form = useForm()
  const formValues = useFormState().values
  const value = useMemo(() => lodash.get(formValues, `${source}.fields`), [formValues, source])

  useEffect(() => {
    let newValue = {}
    if (value?.conditional !== undefined && value?.date) {
      const filterKey = value.conditional === 0 ? afterField : beforeField
      newValue[filterKey] = value.date
    }
    form.change(`${source}.value`, newValue)
  }, [value, source, afterField, beforeField, form])

  return (
    <>
      <SelectInput
        choices={DATE_CHOICES}
        label={false}
        source={`${source}.fields.conditional`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '100px' }}
      />
      <StyledDateInput
        inputVariant={'outlined'}
        source={`${source}.fields.date`}
        label={false}
        options={{ color: 'secondary' }}
        parse={dateParserYYYYMMDD}
      />
    </>
  )
}

export default DateFilter
